import { DWFileShow } from 'src/components/file-show';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWFileShow.displayName, DWFileShow);

export default DWFileShow;

export { DWFileShow };
